export default __webpack_public_path__ + "static/media/ic_share_private_bg.cdd59554.webp";